import React from "react";
import { MapPin, Phone, Mail, Clock, Instagram, Facebook } from "lucide-react";
import { WhatsappIcon } from "../components/icons/WhatsappIcon";

const ContactPage: React.FC = () => {
  window.scrollTo({ top: 0, behavior: "smooth" });
  return (
    <div className="w-full bg-[#fdfaf6] text-gray-800 font-montserrat pb-24">
      {/* Başlık */}
      <section className="text-center py-10 px-4 sm:px-6 bg-[#002744] text-white">
        <h1 className="text-3xl sm:text-4xl md:text-6xl font-bold mb-4">İletişim</h1>
        <p className="text-base sm:text-lg max-w-2xl mx-auto opacity-80">
          Bize ulaşmak çok kolay! Dilersen telefonla ara, mail at ya da doğrudan uğra.
        </p>
      </section>

      {/* Harita + Bilgiler */}
      <section className="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-8 py-12 px-4 sm:px-6">
        {/* Harita */}
        <div className="rounded-xl overflow-hidden shadow-md min-h-[300px] sm:min-h-[400px]">
          <iframe
            title="Ayvalık Marin Konum"
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3797.9755235780763!2d26.714364976467206!3d39.319792921670086!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x14ba7758237925bd%3A0xb4a3e9fe7cf32508!2sAyval%C4%B1k%20Marin!5e1!3m2!1str!2str!4v1752482649329!5m2!1str!2str"
            width="100%"
            height="100%"
            style={{ border: 0 }}
            loading="lazy"
            allowFullScreen
            referrerPolicy="no-referrer-when-downgrade"
          ></iframe>
        </div>

        {/* İletişim Bilgileri */}
        <div className="space-y-6 bg-white rounded-xl shadow-md p-6 sm:p-8">
          <h2 className="text-xl sm:text-2xl font-bold text-[#002744]">
            İletişim Bilgileri
          </h2>

          <div className="flex items-start gap-3">
            <MapPin size={20} className="text-[#009fe3] mt-1" />
            <span className="text-sm sm:text-base leading-snug">
              150 Evler Mah. 29 Mayıs Cad. NO:226 AYVALIK / BALIKESİR
            </span>
          </div>

          <div className="flex items-center gap-3">
            <Phone size={20} className="text-[#009fe3]" />
            <span className="text-sm sm:text-base">0 (266) 331 0 444</span>
          </div>

          <div className="flex items-center gap-3">
            <Mail size={20} className="text-[#009fe3]" />
            <span className="text-sm sm:text-base">info@ayvalikmarin.com.tr</span>
          </div>

          <div className="flex items-center gap-3">
            <Clock size={20} className="text-[#009fe3]" />
            <span className="text-sm sm:text-base">Pzt - Cmt: 09.00 - 18.30</span>
          </div>

          <div className="flex flex-col sm:flex-row sm:flex-wrap sm:gap-4 gap-2 pt-4">
            <a
              href="https://www.instagram.com/ayvalikmarin"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:text-[#009fe3] flex items-center gap-2"
            >
              <Instagram size={20} />
              Instagram
            </a>

            <a
              href="https://www.facebook.com/ayvalikmarin"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:text-[#009fe3] flex items-center gap-2"
            >
              <Facebook size={20} />
              Facebook
            </a>

            <a
              href="https://wa.me/905326036152"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:text-[#009fe3] flex items-center gap-2"
            >
              <WhatsappIcon size={20} />
              WhatsApp
            </a>
          </div>
        </div>
      </section>
    </div>
  );
};

export default ContactPage;
